<template>
  <div>
    <div class="reports">
      <div class="reports-header">
        <div class="reports-item">
          <h1 class="title">{{ $t('reports.myOrders.title') }}</h1>
        </div>
        <div class="reports-item">
          <div class="picker-block">
            <h2>{{ $t('orderList.selectDateRange') }}</h2>
            <div class="datepicker">
              <date-range-picker
                @update="onDatechange"
                v-model="picker"
                opens="right"
                ref="picker"
                auto-apply
              >
              </date-range-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="reports-body" v-show="showMsg">
        <h3>
          {{ $t('reports.myOrders.orders') }} <b>{{ totalOrders }}</b>
          {{ $t('reports.myOrders.mealsFrom') }} <b>{{ startDate }}</b>
          {{ $t('reports.myOrders.mealsTo') }}
          <b>{{ endDate }}</b>
        </h3>
      </div>
    </div>
    <div>
      <el-tabs
        v-loading.fullscreen.lock="loading"
        :class="{ loading: loading }"
        tab-position="left"
        type="card"
      >
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';
import { findOrdersByUser } from '@/services/order';

export default {
  components: {
    DateRangePicker,
  },
  name: 'MyOrders',
  data() {
    return {
      picker: {},
      orders: {},
      totalOrders: 0,
      showMsg: false,
      loading: false,
    };
  },
  computed: {
    ...mapState('global', { adminSelectedOffice: 'adminSelectedOffice' }),
    startDate() {
      return moment(this.picker.startDate).format('MMM Do, YY');
    },
    endDate() {
      return moment(this.picker.endDate).format('MMM Do, YY');
    },
  },
  methods: {
    async getOrdersByUser() {
      this.loading = true;
      const orders = await findOrdersByUser({
        office: this.adminSelectedOffice,
        startDate: moment(this.picker.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.picker.endDate).format('YYYY-MM-DD'),
      });
      this.orders = orders.data.findOrdersByUser;
      this.totalOrders = this.orders.length;
      this.showMsg = true;
      this.loading = false;
    },
    onDatechange(date) {
      this.picker = date;
      this.getOrdersByUser();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';

.reports {
  width: 100%;
  height: 600px;
}

.reports-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 0 30px 0 30px;
  align-items: center;
}
.reports-item {
  width: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.picker-block {
  width: 390px;
  display: flex;
  flex-flow: column;
  padding: 20px;
}
.reports-body {
  width: 60%;
  height: auto;
  margin: 0 30px 0 50px;
}
.table-component {
  width: 70%;
}
.datepicker {
  width: 205px;
  display: flex;
  justify-content: left;
  z-index: 500;
}
.title {
  margin-left: 15px;
  font-weight: $bold-font;
  font-size: $title-font-size;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/MyOrders.vue